<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card
            class="mx-auto d-print-none"
            style="border: darkgreen 2px solid;background-color: linen"
        >
          <v-card-title>
            <v-icon
                large
                left
            >
              mdi-file-edit
            </v-icon>
            <p>เข้าร่วมโครงการ(<span
                style="font-weight: bold;color: #ff6d81">{{ appHeaderName }}</span>)</p>
            <v-spacer></v-spacer>
            <v-btn outlined :color="appColor" @click="$root.$refs.Train.ChooseProcess(TypeProject, true);">
              <span style="font-size: 20px">กลับเมนูหลัก</span>
            </v-btn>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
          </v-card-text>

          <v-card-actions class="justify-space-around">
            <v-list>
              <v-list-item>
                <v-row
                    class="justify-space-around"
                >
                  <v-col align="center" col="12" md="12">
                    <v-btn
                        x-large
                        :outlined="menu.id == HeaderPage"
                        :text="menu.id != HeaderPage"
                        v-for="menu in Menu"
                        :key="menu.id"
                        :color="(menu.id == HeaderPage ? '#1E88E5' : '#607D8B')"
                        @click="goToPage(menu, true)">
                      <h3 style="font-weight: bold">{{ menu.value }}</h3>
                    </v-btn>
                    <hr/>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row
                    class="justify-space-around"
                >
                  <v-col align="center" col="12" md="12">
                    <v-btn
                        x-large
                        :outlined="menu.id == JoinProjectPage"
                        :text="menu.id != JoinProjectPage"
                        v-for="menu in Menu2"
                        :key="menu.id"
                        :color="(menu.id == JoinProjectPage ? '#1E88E5' : '#607D8B')"
                        @click="goToPage(menu, false)">
                      <h3 style="font-weight: bold">{{ menu.value }}</h3>
                    </v-btn>
                    <hr/>
                  </v-col>
                </v-row>
              </v-list-item>
              <router-view></router-view>
            </v-list>
          </v-card-actions>
        </v-card>
      <template>
        <v-dialog
            v-model="dialogProcess"
            max-width="1000"
            persistent>
          <v-card>
            <v-card-title>
            <span style="font-weight: bold">
              จัดโครงการ / จัดอบรมหรือเดินทางไปปฏิบัติราชการ
            </span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt12">
              <row class="d-flex justify-center mt-12">
                <v-col
                    cols="12"
                    md="6"
                    class="d-flex justify-center"
                >
                  <v-btn class="font-weight-bold pa-12" color="primary" @click="ChooseProcess('1')">
                    <span style="font-size: 20px">โครงการ</span>
                  </v-btn>
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                    class="d-flex justify-center"
                >
                  <v-btn class="font-weight-bold pa-12" color="#004D40" dark @click="ChooseProcess('2')">
                    <span style="font-size: 20px">อบรม / เดินทางไปปฏิบัติราชการ</span>
                  </v-btn>
                </v-col>
              </row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLoading"
            persistent
            width="300"
        >
          <v-card
              color="primary"
              dark
          >
            <v-card-text>
              Loading.....
              <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogChooseProcess"
            max-width="800">
          <v-card>
            <v-card-title class="font-weight-bold">
              <span v-if="TypeProject == '1'" style="color: black">โครงการ : เลือกเมนูที่ต้องการทำรายการ</span>
              <span v-else style="color: black">อบรม/เดินทางไปปฏิบัติงาน : เลือกเมนูที่ต้องการทำรายการ</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <template v-if="(TypeProject == null || TypeProject == '1')">
                <v-list-item
                    style="background-color: white"
                >

                  <v-list-item-content>
                    <v-btn  text x-large  @click="goToPage2('/JoinProject/RequestJoinProject')">
                      <span style="color: black;font-size: 16px;font-weight: bold">สมัครเข้าร่วม</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                    style="background-color: white"
                >
                  <v-list-item-content>
                    <v-btn text x-large  @click="goToPage2('/JoinProject/JoinProject')">
                      <span style="color: black;font-size: 16px;font-weight: bold">เพิ่มรายชื่อ</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                    style="background-color: white"
                >
                  <v-list-item-content>
                    <v-btn text x-large  @click="goToPage2('/JoinProject/RegisterProject')">
                      <span style="color: black;font-size: 16px;font-weight: bold">ลงทะเบียนเข้าร่วม</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                    style="background-color: white"
                >
                  <v-list-item-content>
                    <v-btn text x-large  @click="goToPage2('/JoinProject/ExportListData')">
                      <span style="color: black;font-size: 16px;font-weight: bold">EXPORT รายชื่อผู้เข้าร่วม</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark class="font-weight-bold" @click="dialogChooseProcess = false" color="red">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Const from "@/const/Const";

export default {
  name: "JoinProject",
  data() {
    return {
      page: null,
      dialogChooseProcess: false,
      dialogProcess: false,
      dialogLoading: false,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      CheckAdmin: false,
      CheckSubAdmin: true,
      Menu: [
        {
          id: '0',
          value: 'ขอเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan',
          disable: false
        },
        {
          id: '1',
          value: 'จัดโครงการ / เดินทางไปปฏิบัติราชการ',
          page: '/ManageProject',
          disable: false
        },
        {
          id: '2',
          value: 'เข้าร่วมโครงการ',
          page: '/JoinProject',
          disable: false
        }
      ],
      Menu2: [
        {
          id: '0',
          value: 'สมัครเข้าร่วม',
          page: '/JoinProject/RequestJoinProject'
        },
        {
          id: '1',
          value: 'เพิ่มรายชื่อเข้าร่วม',
          page: '/JoinProject/JoinProject'
        },
        {
          id: '2',
          value: 'ลงทะเบียนเข้าร่วม',
          page: '/JoinProject/RegisterProject'
        },
        {
          id: '3',
          value: 'Export รายชื่อผู้เข้าร่วม',
          page: '/JoinProject/ExportListData'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      JoinProjectPage: 'Project/getJoinProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeTypeProject: 'Project/changeTypeProject',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeJoinProjectPage: 'Project/changeJoinProjectPage',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    onResize() {
      this.isMobile = window.innerWidth < 600
    },
    goToPage: function (param, checkMenu) {
      if (checkMenu) {
        this.changeHeaderPage({
          page: param.id
        })
        this.changeJoinProjectPage({
          page: null
        })
      } else {
        this.changeHeaderPage({
          page: '2'
        })
        this.changeJoinProjectPage({
          page: param.id
        })
      }
      this.$router.push(param.page)
    },
    goToPage2: function (param) {
      this.$router.push(param)
      this.dialogChooseProcess = false
    },
    ChooseProcess(page) {
      this.page = null
      this.page = page
      this.changeHeaderPage({
        page: '2'
      })
      this.changeJoinProjectPage({
        page: null
      })
      if (page == '1') {
        this.changeTypeProject({
          type: '1'
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp1
        })
        this.$router.push('/JoinProject')
        this.dialogProcess = false
      } else {
        this.changeTypeProject({
          type: '2'
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp2
        })
        this.$router.push('/JoinProject')
        this.dialogProcess = false
      }
    }
  },
  mounted() {
    this.changeHeaderPage({
      page: '2'
    })
    this.changeJoinProjectPage({
      page: null
    })
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.dialogLoading = true

    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '10'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            // if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '10' && item.page_status == '1').length > 0) {
            this.maintain = false
            this.getPermissionData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                this.PermissionAdmin.map((Per_i, idx) => {
                  if (Per_i.permission_id == '7000') {
                    this.getMenuPermissData().then(res => {
                      if (res) {
                        if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '10' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          // this.TypeProject == null ? this.dialogProcess = true : this.ChooseProcess(this.TypeProject)
                          this.ChooseProcess('1')
                          this.dialogChooseProcess = true
                          this.dialogLoading = false
                        } else {
                          this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '10' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '10' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                      }
                    })
                    this.CheckAdmin = true
                    this.dialogLoading = false
                  } else {
                    if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                // this.$router.push('/')
                this.getPermissionUserData({
                  perid: this.MeData[0].perid
                }).then(res => {
                  if (res) {
                    this.Permission.map((Per_i, idx) => {
                      if (Per_i.permission_id == '7000') {
                        this.getMenuPermissData().then(res => {
                          if (res) {
                            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '10' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                              this.maintain = false
                              // this.TypeProject == null ? this.dialogProcess = true : this.ChooseProcess(this.TypeProject)
                              this.ChooseProcess('1')
                              this.dialogChooseProcess = true
                              this.dialogLoading = false
                            } else {
                              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '10' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                              this.maintain = true
                            }
                          }
                        }).then(err => {
                          if (err) {
                            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '10' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                            this.maintain = true
                          }
                        })
                        this.CheckSubAdmin = true
                        this.dialogLoading = false
                      } else {
                        if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                          this.dialogLoading = false
                          this.$router.push('/')
                        }
                      }
                    })
                  } else {
                    this.CheckSubAdmin = false
                    this.CheckAdmin = false
                    this.dialogLoading = false
                    this.$router.push('/')
                  }
                })
              }
            })
            // } else {
            //   this.maintain = true
            // }
          }
        }).then(err => {
          if (err) {
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
